<!--
  UIID: UI-Caas-MON-120
  UI Name: Status Information (popup)
  Modify Date: 2020/06/17
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display monitor-srch-layout-dialog"
    style="height:314px !important;width:562px !important;"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>Event Message</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog($event)" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg class="ml-2" iconName="close" />
      </v-btn>
    </template>
    <v-card class="v-dialog-1 custom-card-text pl-4 pr-4">
      <v-card-text class="pb-0 card-text-scroll">
        <v-row class="no-gutters mt-0 status-section-mb">
          <v-col cols="12" class="pr-0 pt-0 pb-2 text-right">
            <v-textarea v-model="dataValue" hide-details outlined diasbled dense height="140"></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-divider class="ml-0 mr-0 mt-2 divder-popup" inset></v-divider>
    <v-row class="ml-0 mr-0">
      <v-col class="button-col action-col" lg="12">
        <div class="btn-form-control text-right mr-4">
          <v-btn class="btn btn-delete" @click="removeDialog">{{$t('btn.common.close')}}</v-btn>
        </div>
      </v-col>
    </v-row>
  </dialog-drag>
</template>

<script>
import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import IconSvg from "@/vue-caas/components/IconBase.vue";
const moment = require("moment");

export default {
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    errorMessage: String,
  },
  components: {
    DialogDrag,
    IconSvg,
  },
  name: "input-searchkey-view-window",

  data() {
    return {
      dataValue: "",
    };
  },

  methods: {
    initialize() {
      this.dataValue = this.errorMessage;
    },

    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },

  created() {
    this.initialize();
  },
};
</script>

<style>
.theme--dark .custom-card-text .v-card__text {
  font-size: 13px;
  /* line-height: 19px; */
  background-color: #3b3e49;
}

.custom-card-text
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding-left: 12px !important;
}
</style>